// extracted by mini-css-extract-plugin
module.exports = {"RealestateVisaUserText":"RealestateVisaUserField_RealestateVisaUserText__3zZ4p","RealestateUserInput":"RealestateVisaUserField_RealestateUserInput__12bF0"};